import React, { useRef, useState } from "react";
import Layout from "./Layout";
import useTableFunction from "../../../hooks/useTableFunction";
import { COLLECTION } from "../../../data/constant";
import { getDownloadURL, listAll, ref } from "firebase/storage";
import { db, storage } from "../../../config/firebase";
import { useEffect } from "react";
import { transactionTableHeading } from "../../../assets/lib/cartingTool";
import { doc,where,  getDoc, setDoc } from "firebase/firestore";
import { collection, query,addDoc,getDocs ,updateDoc,getCountFromServer} from "firebase/firestore";

import moment from "moment";

const CartLoading =  () => {

  const dynamicConditionCB = async () => {
    return {
      column: "phoneNumber",
      operator: "==",
      query: "9741726760",
    };
  };

  const {
    tableData,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
    handleSearchDate,
  } = useTableFunction({
    collectionPath: COLLECTION.TRANSACTIONS,
    dynamicCondition:dynamicConditionCB,
    //defaultOrderBy: "date",
    defaultOrderBy: {
      field: "transactionTime",
      direction: "desc",
    }
  });

  const [images, setImages] = useState("");
  const [updateTransId, setUpdateTransId] = useState("");
  const [menuItems, setMenuItems] = useState([]);
  const [currentImagesfirst, setCurrentImagesfirst] = useState(null);
  const [currentImages, setCurrentImages] = useState(null);
  const [cameraGroup, setCameraGroup] = useState([]);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addedItems, setAddedItems] = useState([]);
  const [validationErrors, setValidationErrors] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [fromDate, setFromDate] = useState(moment());
  const [toDate, setToDate] = useState(moment());
  const isCloseCalledRef = useRef(false);
  const updateTransIdRef = useRef(0);
  const [MachineID,setMachineID]=useState("");

  const groupAndSortItems = (items) => {
    const validItems = items.filter((item) => typeof item === "string");
    // Sort items based on the first number in their names
    const sortedItems = validItems.sort((a, b) => {
      const numA = parseInt(a.split("_")[0]);
      const numB = parseInt(b.split("_")[0]);
      return numA - numB;
    });
    // Group items based on the second part of their names
    const groupedItems = {};
    sortedItems.forEach((item) => {
      const parts = item.split("_");
      const key = parts[1]; // Assuming the second part is the key for grouping
      if (!groupedItems[key]) {
        groupedItems[key] = [];
      }
      groupedItems[key].push(item);
    });
    const resultArray = Object.values(groupedItems);
    setImages(resultArray)
    return resultArray;
  };

  const displayImageSequentiallyfirst = async (
    startIndex,
    group,
    transactionRef,
    cameraNum
  ) => {
    if (isCloseCalledRef.current) {
      return;
    }
    const imageName = group[startIndex];
    const imageUrl = await getDownloadURL(ref(transactionRef, imageName));
    const image = {
      [cameraNum]: { imageUrl, imageName },
    };
    setCurrentImagesfirst((prevState) => ({
      ...prevState,
      ...image,
    }));
    if (isModalLoading) {
      setIsModalLoading(false);
    }
    await new Promise((resolve) => setTimeout(resolve,10));
  };

  const displayImageSequentially = async (
    startIndex,
    group,
    transactionRef,
    cameraNum
  ) => {
    for (let index = startIndex; index < group.length; index++) {
      if (isCloseCalledRef.current) {
        return;
      }
      const imageName = group[index];
      const imageUrl = await getDownloadURL(ref(transactionRef, imageName));
      const image = {
        [cameraNum]: { imageUrl, imageName },
      };
      setCurrentImages((prevState) => ({
        ...prevState,
        ...image,
      }));
      if (isModalLoading) {
        setIsModalLoading(false);
      }
      await new Promise((resolve) => setTimeout(resolve,10));
    }
  };

  const fetchImages = async (updateTrasactionData) => {
    isCloseCalledRef.current = false;
    if (updateTrasactionData.id) {
      setIsModalLoading(true);
      updateTransIdRef.current = updateTrasactionData.id;
      const transactionRef = ref(
        storage,
        `transactions/${updateTrasactionData.id}`
      );
      try {
        // Fetch the list of images
        const list = await listAll(transactionRef);
        const sortedFileNames = list.items.map((itemRef) => itemRef.name);
        const group = groupAndSortItems(sortedFileNames);
        if (group && group.length === 0) {
          setIsModalLoading(false);
          return;
        }
        setCurrentImagesfirst(null)
        setCurrentImages(null); // Reset the current content
        setCameraGroup(group);

        // Fetch the menu items
        const inventoryDocRef = doc(
          db,
          COLLECTION.INVENTORY,
          updateTrasactionData.machineId
        );
        const inventoryDocSnap = await getDoc(inventoryDocRef);

        if (inventoryDocSnap.exists()) {
          let allItemsArray = [];
          const inventoryData = inventoryDocSnap.data();
          Object.keys(inventoryData).forEach((item) => {
            allItemsArray.push({
              itemKey: item,
              ...inventoryData[item],
            });
          });
          setMenuItems(allItemsArray);
        }
      } catch (error) {
        console.error("Error listing files:", error);
      }
    }
  };

  const fetchCameraImagesfirst = async (cameraGroup) => {
    const updateTransId = updateTransIdRef.current;
    if (updateTransId) {
      const transactionRef = ref(storage, `transactions/${updateTransId}`);
      if (cameraGroup.length > 0) {
        await Promise.all(
          cameraGroup.map(async (camera, idx) => {
            await displayImageSequentiallyfirst(0, camera, transactionRef, idx);
          })
        );
      }
    }
  };

  const fetchCameraImages = async (cameraGroup) => {
    const updateTransId = updateTransIdRef.current;
    if (updateTransId) {
      const transactionRef = ref(storage, `transactions/${updateTransId}`);
      if (cameraGroup.length > 0) {
        await Promise.all(
          cameraGroup.map(async (camera, idx) => {
            await displayImageSequentially(0, camera, transactionRef, idx);
          })
        );
      }
    }
  };

  const onCloseModal = () => {
    isCloseCalledRef.current = true;
    // Inorder to stop the for loop wait till the execution is stoped
    setTimeout(() => {
      updateTransIdRef.current = 0;
      setCurrentImagesfirst(null)
      setCurrentImages(null);
      setIsModalLoading(false);
      setCameraGroup([]);
      setIsModalOpen(false);
    }, 500);
  };

  const onClickDateSearch = () => {
    handleSearchDate(fromDate, toDate, "transactionTime");
  };

  const handleAddItem = () => {
    setAddedItems((prevItems) => [
      ...prevItems,
      {
        id: prevItems[prevItems.length - 1].id + 1,
        selectedItem: menuItems[0],
        quantity: 0,
      },
    ]);
  };

  const handleDeleteItem = (id) => {
    if (addedItems.length > 1) {
      setAddedItems((prevItems) => prevItems.filter((item) => item.id !== id));
    }
    setValidationErrors((prevErrors) => {
      if (prevErrors.some((error) => error.id === id)) {
        return prevErrors.filter((error) => error.id !== id);
      }
      return prevErrors;
    });
  };

  const onChangeValue = (value, id) => {
    setValidationErrors((prevErrors) => {
      if (value > 0 && prevErrors.some((error) => error.id === id)) {
        console.log(
          "prevErrors",
          prevErrors.filter((error) => error.id !== id)
        );
        return prevErrors.filter((error) => error.id !== id);
      }
      return prevErrors;
    });
    setAddedItems((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.id === id ? { ...item, quantity: value } : item
      );
      return updatedItems;
    });
  };

// to fetch amount
const handleSubmit = async () => {
  const newValidationErrors = addedItems.filter((item) => item.quantity <= 0);
  setValidationErrors(newValidationErrors);
  const isQuantityValid = newValidationErrors.length === 0;

  // ✅ If nothing added OR all qty <= 0, treat as "No Load"
  const isNoLoad = addedItems.length === 0 || addedItems.every(item => item.quantity <= 0);

  try {
    setSubmitLoading(true);

    if ((isQuantityValid || isNoLoad) && updateTransIdRef.current) {
      const transactionId = updateTransIdRef.current;
      const documentRef = doc(db, COLLECTION.TRANSACTIONS, transactionId);
      const transactionSnap = await getDoc(documentRef);

      if (!transactionSnap.exists()) {
        throw new Error("Transaction document not found.");
      }

      const transactionData = transactionSnap.data();
      const phoneNumber = transactionData.phoneNumber || "";
      const machineId = transactionData.machineId || "";

      let totalPrice = 0;
      const items = [];

      // ✅ Only calculate if it's NOT a no-load case
      if (!isNoLoad) {
        addedItems.forEach((item) => {
          const quantity = parseInt(item.quantity);
          const pricePerOne = item.selectedItem.unitPrice / item.selectedItem.quantity;
          const itemTotal = quantity * pricePerOne;
          totalPrice += itemTotal;

          items.push({
            itemName: item.selectedItem.productName,
            productId: item.selectedItem.productId,
            quantity: quantity,
            unitPrice: pricePerOne,
            totalPrice: itemTotal,
          });
        });
      }

      // ✅ Save to CartLoading
      const cartLoadingRef = collection(db, "CartLoading");
      const cartDocRef = await addDoc(cartLoadingRef, {
        transactionId,
        podNumber: machineId,
        phoneNumber,
        timestamp: new Date(),
        items,
        totalPrice,
        noLoad: isNoLoad // flag
      });

      // ✅ Update Transaction Status
      await updateDoc(documentRef, {
        cartingStatus: isNoLoad ? "No Load" : "Loaded",
        cartLoadingId: cartDocRef.id 
      });

      setSubmitLoading(false);
      setIsModalOpen(false);

    } else {
      console.error("Quantity must be greater than 0 for all added items");
      setSubmitLoading(false);
      setIsModalOpen(false);
    }

  } catch (error) {
    console.error("Submission error:", error);
    setSubmitLoading(false);
    setIsModalOpen(false);
  }
};


  useEffect(() => {
    if (menuItems.length > 0)
      setAddedItems([{ id: 1, selectedItem: menuItems[0], quantity: 0 }]);
  }, [menuItems]);

  useEffect(() => {
    if (cameraGroup && cameraGroup.length > 0) {
      fetchCameraImagesfirst(cameraGroup)
      fetchCameraImages(cameraGroup);
    }
  }, [cameraGroup]);

  return (
    <Layout
      transactionTableHeading={transactionTableHeading}
      transactionTableData={tableData}
      isTableLoading={isTableLoading}
      currentPage={currentPage}
      totalLength={totalLength}
      handlePageChange={handlePageChange}
      handlePageSize={handlePageSize}
      handleSearchQuery={handleSearchQuery}
      handleTableSorting={handleTableSorting}
      updateTransId={updateTransId}
      setUpdateTransId={setUpdateTransId}
      fetchImages={fetchImages}
      currentImages={currentImages}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      onCloseModal={onCloseModal}
      isModalLoading={isModalLoading}
      menuItems={menuItems}
      addedItems={addedItems}
      setAddedItems={setAddedItems}
      handleAddItem={handleAddItem}
      handleDeleteItem={handleDeleteItem}
      onChangeValue={onChangeValue}
      handleSubmit={handleSubmit}
      validationErrors={validationErrors}
      submitLoading={submitLoading}
      fromDate={fromDate}
      setFromDate={setFromDate}
      toDate={toDate}
      setToDate={setToDate}
      onClickDateSearch={onClickDateSearch}
      images={images}
      currentImagesfirst={currentImagesfirst}
    />
  );
};

export default CartLoading;
